// tslint:disable: max-line-length triple-equals
import React, { useEffect, useState } from 'react';
import Icon from 'lqa-ui/lib/Components/Icon';
import {
  AssessmentSummaryAPI,
  getAssessmentAttachments,
  SelfAssessmentSummaryAPI,
  starEmployess,
} from './../../requests/assessements';
import { assessments as assessmentApi } from '../Dashboard/apiCaller';
import { Collapse } from 'react-collapse';
import { round, sum } from 'lodash';
import Avatar from 'lqa-ui/lib/Components/Avatar';
import { getItem, removeItem, setItem } from '../../utils/localStorage';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { StandardPerformaceSelector } from '../../components/commons/StandardPerformanceSelector/standardPerformanceSelector';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { getDepartmentApi } from '../../components/SelfAssessmentAssignDepartment/apiCaller';
import '../../style/main.scss';
import ImageOverlay from 'lqa-ui/lib/Components/ImageOverlay';
import { OverlayAudio } from '../../components/commons/AudioPlayer/OverlayAudio';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import { translateMealPeriodLabel } from '../../enums/labels/MealPeriod';
import DownArrowIcon from '../../components/commons/icons/down_arrow';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import NonIdealState from 'lqa-ui/lib/Components/NonIdealState';
import { showErrorMessage } from '../../helpers/showMessage';
import { ANNONYMOUS_NAME } from '../../utils/regex';
import AccessDenied from '../AccessDenied';
import { DEFAULT_VIEW } from '../../utils/constants';
import { isUnauthorized } from '../../utils/common';
import { getTemplateData } from '../../requests/login';
import { uniq } from 'lodash';
import PendingAssessment from '../commons/PendingAssessment';
import {
  getBrandAndHotelData,
  gethasAssessment,
} from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  AssessmentContainer,
  StarEmployeesContainer,
  BencharmkOverallListItem,
  BencharmkOverallListItemContent,
  BenchmarkOverallCollapseContent,
  HoteLScoreContainer,
  DepartamentLabelContainer,
  DropdownArrowContainer,
  LockInconContainer,
  StarEmployeesContent,
  AvatarContent,
  AvatarContainer,
  StarIconContainer,
  TitleOverall,
  OverallScore,
  CardContainer,
  CardContent,
  CardTitle,
  CardOverall,
  CardScore,
  HotelScoreTitle,
  DepartamentCard,
  DepartamentText,
  DepartamentTitle,
  DepartamentOverall,
  DepartamentDescription,
  DepartamentIconsContianer,
  ModalContainer,
  BorderLine,
  PrimaryEmotionContainer,
  NarrativeTitle,
  NarrativeDescription,
  CompliancySummaryContainer,
  ButtonWrapper,
} from './Assessment.styled';
import {
  Body3,
  Body4,
  Body5,
  Body6,
  Headline3,
  Headline4,
  Headline5,
  Headline6,
} from './../../app/common/typography';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { BottomSheet } from '../../app/common/sharedComponents/BottomSheet';
import { StarWithBorder } from './../../app/common/icons/StarWithBorder';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { UserTypeEnum } from '../../app/common/enum/generic';

const getEqBgColor = (eqScore) => {
  if (eqScore == 5) {
    return '58C3BB';
  }
  if (eqScore == 4) {
    return 'ABE1DD';
  }
  if (eqScore == 3) {
    return 'F8E58A';
  }
  if (eqScore == 2) {
    return 'F79BA6';
  }
  if (eqScore == 1) {
    return 'CC3044';
  } else {
    return 'white';
  }
};

const labelValue = (value) => {
  switch (value) {
    case 1:
      return '1 Point- Extremely Dissatisfied';
    case 2:
      return '2 Points- Dissatisfied';
    case 3:
      return '3 points- Engaged';
    case 4:
      return '4 Points- Positively Engaged';
    case 5:
      return '5 Points - Completely Engaged';
    default:
      return '';
  }
};

const getEqTextColor = (eqScore) => {
  if (eqScore == 2) {
    return 'white';
  } else {
    return 'black';
  }
};

const Assessment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const loc: any = { ...location };
  const { state } = loc;
  let isSelf;
  let assessmentDate;
  let assessmentId;
  let duplicateCategoryAssessed;
  let evnt;
  let isNotGraded;
  let passsTemplate;
  let selfAssessmentData;
  let selfStayStart;
  if (loc.state) {
    isSelf = loc.state.isSelf;
    assessmentDate = loc.state.assessmentDate;
    assessmentId = loc.state.assessmentId;
    duplicateCategoryAssessed = loc.state.duplicateCategoryAssessed;
    evnt = loc.state.evnt;
    isNotGraded = loc.state.isNotGraded;
    passsTemplate = loc.state.passsTemplate;
    selfAssessmentData = loc.state.selfAssessmentData;
    selfStayStart = loc.state.selfStayStart;
  }
  const userData = getItem('user');
  const allHotels = getBrandAndHotelData();
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());
  const isViewer =
    userData && userData.user && userData.user.userType === UserTypeEnum.noData;
  const [toggle, setToggle] = useState([false]);
  const [showCom, setShowCom] = useState(false);
  const [showEq, setShowEq] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient')
  );
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [starEmployee, setStartEmployee] = useState<any>(undefined);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [performanceClassification, setPerformaceClassification] =
    useState('all');
  const [openPressAndHold, setOpenPressHold] = useState(false);
  const [tempData, setTempData] = useState<any>(undefined);
  const [audioOverlayOpened, setAudioOverlayOpened] = useState(false);
  const [audio, setAudio] = useState<
    | {
      url: string;
      notes: string;
    }[]
    | []
  >([]);
  const [apiData, setApiData] = useState<
    | {
      data: any[];
      overall: any;
    }
    | undefined
  >(undefined);

  const brandId = getItem('selectedBrand');
  const defaultValues = DEFAULT_VIEW.find((o: any) => o.brandId === brandId);
  const initialStandard = (state && state.standard) ||
    (defaultValues && defaultValues.defaultCustomScoreNumber) || 'LQA';
  const [standard, setStandard] = useState(initialStandard);
  const [pressHoldData, setPressHoldData] = useState<any>({
    sourceCategoryId: null,
    visit: null,
  });

  const [loader, setLoader] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [eqData, setEqData] = useState<
    | {
      additionalText: string;
      benchmarkTemplateCategoryId: number;
      duplicateCategoryId: number;
      negativeText: string;
      positiveText: string;
      recommendText: string;
      templateCategoryId: number;
      templateEqDescription: string;
      templateEqLabel: string;
      templateEqValue: number;
      visit: number;
      subName: string;
      depCommentary: string;
      time: any;
    }
    | undefined
  >(undefined);
  const [imgAttach, setImgAttach] = useState<
    | {
      templateCategoryId: number;
      url: string;
      notes: string;
    }[]
    | undefined
  >(undefined);
  const [audioAttach, setAudioAttach] = useState<
    | {
      templateCategoryId: number;
      url: string;
      notes: string;
    }[]
    | []
  >([]);
  const isSubDepartmentUser =
    userData && userData.user && userData.user.userType === 'subDepartment';

  useEffect(() => {
    if (!isSelf && assessments) {
      const asse = assessments.find((o) => o.stayStart === selectedAssessment);
      assessmentId = asse ? asse.id : '-1';
    }
    if (
      assessmentId &&
      assessmentId !== '-1' &&
      assessments &&
      assessments.length > 0
    ) {
      getAssessmentAttachments(assessmentId)
        .then((res) => {
          setImgAttach(res.imageAttachments);
          setAudioAttach(res.audioAttachments);
        })
        .catch((err) => {
          showErrorMessage(
            'Error while getting attachments',
            !isUnauthorized(err)
          );
        });
    }
  }, [assessmentId, assessments]);

  useEffect(() => {
    setHasAssessment(getItem('hasAssessment'));
  }, [selectedHotel, selectedClient, isSelf]);

  useEffect(() => {
    if (selectedHotel && hasAssessment) {
      assessmentApi()
        .then((response) => {
          setAssessments(response);
          getDepartmentApi()
            .then((responseData) => {
              setTempData(responseData.data);
              setLoader(false);
            })
            .catch((err) => {
              showErrorMessage(
                'Could not load Template Data',
                !isUnauthorized(err)
              );
            });

          if (isSelf) {
            setSelectedAssessment(assessmentDate);
          } else {
            const assess = response.find(
              (o) => o.stayStart === getItem('selectedAssessmentDate')
            )
              ? getItem('selectedAssessmentDate')
              : undefined;
            setSelectedAssessment(assess ? assess : response[0].stayStart);
          }
          setStandard(initialStandard);
        })
        .catch((err) => {
          showErrorMessage('Could not load Assessment', !isUnauthorized(err));
        });
    }
  }, [selectedHotel, selectedClient, hasAssessment]);

  useEffect(() => {
    if (selectedAssessment) {
      setLoader(true);
      if (isSelf) {
        setApiData(undefined);
        if (assessmentId && standard && performanceClassification) {
          SelfAssessmentSummaryAPI(
            assessmentId,
            standard,
            performanceClassification
          )
            .then((res) => {
              setApiData(res);
              setLoader(false);
            })
            .catch((err) => {
              showErrorMessage(
                'Could not find self assessment data',
                !isUnauthorized(err)
              );
            });
        }
      } else {
        if (
          selectedAssessment &&
          standard &&
          performanceClassification &&
          hasAssessment
        ) {
          AssessmentSummaryAPI(
            selectedAssessment,
            standard,
            performanceClassification
          )
            .then((res) => {
              if (res) {
                setApiData(res);
                getDepartmentApi()
                  .then((responseData) => {
                    setTempData(responseData.data);
                    setLoader(false);
                  })
                  .catch((err) => {
                    showErrorMessage(
                      'Could not load template data',
                      !isUnauthorized(err)
                    );
                  });
              }
            })
            .catch((err) => {
              showErrorMessage(
                'Could not find assessment data',
                !isUnauthorized(err)
              );
            });
        }
      }
      if (selectedAssessment && !isSelf) {
        starEmployess(selectedAssessment)
          .then((res) => setStartEmployee(res))
          .catch((err) => {
            showErrorMessage(
              'Could not find star employee',
              !isUnauthorized(err)
            );
          });
      }
    }
  }, [selectedAssessment, standard, performanceClassification, isSelf]);

  const handleCollapsible = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!toggle[index]) {
      collapse[index] = true;
    } else {
      if (toggle[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    setToggle(collapse);
  };

  const getSelectedCategories = (catData) => {
    const selfAssessmentSelectedCategory: any[] = [];
    selfAssessmentSelectedCategory.push(catData.sourceTemplateCategoryId);
    let parentCat: any = {};
    let parentId = catData.parentId;
    do {
      parentCat = apiData
        ? apiData.data.find((apData) => apData.id == parentId)
        : [];
      if (parentCat) {
        parentId = parentCat.parentId;
        selfAssessmentSelectedCategory.push(parentCat.sourceTemplateCategoryId);
      } else if (parentId && !parentCat) {
        selfAssessmentSelectedCategory.push(parentId);
      }
    } while (parentCat && !!parentCat.parentId);

    return selfAssessmentSelectedCategory;
  };

  const portal = () => {
    if (!eqData) {
      return;
    }

    const onModalClose = () => {
      setOpen(false);
      setShowEq(false);
      setShowCom(false);
    };

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        isShowCloseIcon={true}
        isOpen={isOpen}
        handleModalClose={() => onModalClose()}
      >
        <ModalContainer showEq={showEq || showCom}>
          <Headline3 color="verdigris">
            {t('COMMON.EI_BEHAVIORAL.EI_BEHAVIORAL_CONNECTION')}
          </Headline3>
          <Body4 color="eerieBlack">
            {eqData.time ? moment(eqData.time).format('Do MMM YY  HH:mm') : ''}
          </Body4>
          <BorderLine />
          <PrimaryEmotionContainer>
            Primary Emotion{' '}
            <span className={`p-5 ${eqData.templateEqValue ? '' : 'd-none'}`}>
              <span
                className={`p-5 border-radius-10 f-15 ${eqData.templateEqValue
                    ? 'background-' +
                    getEqBgColor(round(eqData.templateEqValue))
                    : 'background-white'
                  }`}
              >
                {eqData.templateEqDescription
                  ? `${eqData.templateEqDescription}`
                  : ''}
              </span>
            </span>
          </PrimaryEmotionContainer>
          <Body4 color="eerieBlack">
            {labelValue(round(eqData.templateEqValue))}
          </Body4>
          <div className={`p-10 ${showEq ? 'd-block' : 'd-none'}`}>
            {eqData.additionalText && (
              <>
                <NarrativeTitle color="eerieBlack">
                  {t('COMMON.EI_BEHAVIORAL.EI_BEHAVIORAL_CONNECTION')}
                </NarrativeTitle>
                <NarrativeDescription>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        eqData && typeof eqData.additionalText === 'string'
                          ? eqData.additionalText.replace(
                            ANNONYMOUS_NAME,
                            'employee'
                          )
                          : '',
                    }}
                  />
                </NarrativeDescription>
                <br />
              </>
            )}
            {eqData.positiveText && (
              <>
                <NarrativeTitle color="eerieBlack">
                  Positive Aspects
                </NarrativeTitle>
                <NarrativeDescription>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        eqData && typeof eqData.positiveText === 'string'
                          ? eqData.positiveText.replace(
                            ANNONYMOUS_NAME,
                            'employee'
                          )
                          : '',
                    }}
                  />
                </NarrativeDescription>
                <br />
              </>
            )}
            {eqData.negativeText && (
              <>
                <NarrativeTitle color="eerieBlack">
                  Negative Aspects
                </NarrativeTitle>
                <NarrativeDescription>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        eqData && typeof eqData.negativeText === 'string'
                          ? eqData.negativeText.replace(
                            ANNONYMOUS_NAME,
                            'employee'
                          )
                          : '',
                    }}
                  />
                </NarrativeDescription>
                <br />
              </>
            )}
            {eqData.recommendText && (
              <>
                <NarrativeTitle color="eerieBlack">
                  Recommendations
                </NarrativeTitle>
                <NarrativeDescription>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        eqData && typeof eqData.recommendText === 'string'
                          ? eqData.recommendText.replace(
                            ANNONYMOUS_NAME,
                            'employee'
                          )
                          : '',
                    }}
                  />
                </NarrativeDescription>
                <br />
              </>
            )}
          </div>

          <div onClick={() => setShowEq(!showEq)}>
            <Body4 color="battleShipGray" className="text-underline">
              {showEq ? 'Collapse' : 'See'} Narrative
            </Body4>
          </div>
          <BorderLine />
          {eqData.depCommentary && (
            <>
              <Headline3 color="verdigris">Compliancy Summary</Headline3>
              <Body4 color="eerieBlack">
                {eqData.time
                  ? moment(eqData.time).format('DD MMM YY - HH:mm')
                  : ''}
              </Body4>
              <Body4 color="eerieBlack">{eqData.subName}</Body4>
              <br />
              <CompliancySummaryContainer
                className={`${showCom ? 'd-block' : 'd-none'}`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      eqData && typeof eqData.depCommentary === 'string'
                        ? eqData.depCommentary.replace(
                          ANNONYMOUS_NAME,
                          'employee'
                        )
                        : '',
                  }}
                />
              </CompliancySummaryContainer>

              <div onClick={() => setShowCom(!showCom)}>
                <Body4 color="battleShipGray" className="text-underline">
                  {showCom ? 'Collapse' : 'See'} Narrative
                </Body4>
              </div>
            </>
          )}
        </ModalContainer>
      </Modal>
    );
  };

  const pressAndHoldMenu = () => {
    const alreadyAssignedUsers =
      userData && userData.user && userData.user.id ? [userData.user.id] : [];
    if (!pressHoldData) {
      return;
    }
    const selectedCategories = uniq(getSelectedCategories(pressHoldData));
    const isDepartmentAvailable = async (selectedCategories) => {
      const defaultTemplateId = getItem('defaultTemplateId');
      const templateData: any = await getTemplateData(
        defaultTemplateId,
        userData
      );
      if (
        templateData &&
        templateData.category.length &&
        templateData.category.filter((k) =>
          selectedCategories.includes(k.sourceTemplateCategoryId)
        ) &&
        templateData.category.filter((k) =>
          selectedCategories.includes(k.sourceTemplateCategoryId)
        ).length !== selectedCategories.length
      ) {
        showErrorMessage(
          'This department is not included in your current template'
        );
        setOpenPressHold(false);
        return true;
      } else {
        return false;
      }
    };

    return (
      <BottomSheet
        isOpen={openPressAndHold}
        onClose={() => setOpenPressHold(false)}
      >
        <ButtonWrapper>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t(
                'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_ACTION_PLAN'
              )}
              onClick={async () => {
                if (await isDepartmentAvailable(selectedCategories)) {
                  return;
                }
                navigate('/createActionPlan', {
                  state: {
                    sourceTemplateCategoryId:
                      pressHoldData.sourceTemplateCategoryId,
                    visit: pressHoldData.visit,
                    selectedAssessment,
                    alreadyAssignedUsers,
                    selfAssessmentId: assessmentId,
                    selfStayStart,
                  },
                });
              }}
              backgroundColor="oxfordBlue"
            />
            {!isSelf && (
              <ButtonLarge
                title={t(
                  'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_SELF_ASSESSMENT'
                )}
                onClick={() => {
                  const saTemplateId =
                    tempData.length > 0 && tempData[0].templateId;
                  const subDepartmentName = pressHoldData.name;
                  setItem('saTemplateId', saTemplateId);
                  removeItem('parentAssessment');
                  removeItem('selfAssessments');
                  removeItem('disabledCategories');
                  navigate('/selfAssessment/selectDepartments', {
                    state: { subDepartmentName, templateId: saTemplateId },
                  });
                }}
                outlined={true}
                inverted={true}
              />
            )}
          </ButtonBlockColumn>
        </ButtonWrapper>
      </BottomSheet>
    );
  };
  if (!userData || !userData.user || !userData.user.brands || allHotels <= 0) {
    return <AccessDenied tabname="Assessments" />;
  }
  if (!isSelf && !hasAssessment) {
    return (
      <>
        <PendingAssessment
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={loader}
          setIsLoading={setLoader}
          selectedCompset={0}
          setSelectedCompset={() => { }}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </>
    );
  }
  if (
    (isSelf && apiData && apiData.data.length <= 0) ||
    (isSelf && evnt === 'sent' && isNotGraded)
  ) {
    return (
      <>
        <HeaderContainer>
          <AppHeader
            title={t('COMMON.ASSESSMENT.TITLE')}
            hasBackButton={isSelf ? true : false}
          />
        </HeaderContainer>
        <div className="pt-80 p-20">
          <h1 className="color-black background-none mb-20">
            Self Assessment Detail
          </h1>
          <br />
        </div>
        <NonIdealState
          className="pt-80"
          title="Self Assessment not Graded"
          description={
            performanceClassification !== 'all'
              ? 'This Self Assessment has no data for this performation Classification'
              : 'Please wait for Assignee to Submit'
          }
          icon="illustration-nonideal"
          iconOffset={[10, -20]}
        />
      </>
    );
  }

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.ASSESSMENT.TITLE')}
          hasBackButton={isSelf}
        />
        {!isSelf && (
          <HotelAssessmentSelection
            assessments={assessments}
            setAssessments={setAssessments}
            selectedHotel={selectedHotel}
            setSelectedHotel={setSelectedHotel}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            selectedAssessment={selectedAssessment}
            setSelectedAssessment={setSelectedAssessment}
            isSelectDate={true}
            isLoading={loader}
            setIsLoading={setLoader}
            selectedCompset={0}
            setSelectedCompset={() => { }}
            hasAssessment={hasAssessment}
            setHasAssessment={setHasAssessment}
          />
        )}
        {!isViewer &&
          starEmployee &&
          starEmployee.starEmployees.length > 0 &&
          !isSelf && (
            <StarEmployeesContainer isViewer={isViewer} isSelf={isSelf}>
              <Headline3 color="white">Star Employees</Headline3>
              <StarEmployeesContent>
                {starEmployee.starEmployees &&
                  starEmployee.starEmployees.map((star) => {
                    return (
                      // tslint:disable-next-line:jsx-key
                      <AvatarContainer>
                        <AvatarContent>
                          <Avatar
                            name={`${star.name}`}
                            size={54}
                            style={{ background: '#4fada6' }}
                          />
                          <StarIconContainer>
                            <StarWithBorder />
                          </StarIconContainer>
                        </AvatarContent>
                        <Body6 color="white">{star.name}</Body6>
                      </AvatarContainer>
                    );
                  })}
              </StarEmployeesContent>
            </StarEmployeesContainer>
          )}
      </HeaderContainer>
      <div className={isViewer ? 'blur' : ''}>
        {!apiData || loader || !selectedAssessment || !imgAttach ? (
          <AssessmentContainer>
            <div className="box-shadow d-block">
              <Skeleton
                containerClassName="flex-1"
                height={150}
                borderRadius={5}
              />
              <div className="m-10 mb-10">
                <div className="row-separater-skeleton mb-10">
                  <Skeleton width={150} height={50} borderRadius={5} />
                  <Skeleton width={150} height={50} borderRadius={5} />
                </div>
                <div className="row-separater-skeleton mb-10">
                  <Skeleton width={150} height={30} borderRadius={5} />
                  <Skeleton width={50} height={25} borderRadius={5} />
                </div>
                <Skeleton
                  containerClassName="flex-1"
                  height={50}
                  borderRadius={5}
                  count={5}
                />
              </div>
            </div>
          </AssessmentContainer>
        ) : (
          <AssessmentContainer
            isSelf={isSelf}
            isViewer={isViewer || starEmployee.starEmployees.length === 0}
          >
            {isViewer && !isSelf ? (
              <LockInconContainer>
                <Icon kind="lock" height={40} width={40} />
              </LockInconContainer>
            ) : (
              <></>
            )}
            {portal()}
            {pressAndHoldMenu()}
            {!isSubDepartmentUser && hasAssessment && (
              <StandardPerformaceSelector
                standard={standard}
                setStandard={setStandard}
                selectedHotel={selectedHotel}
                selectedClient={selectedClient}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformaceClassification}
                isSelf={false}
              />
            )}
            {!isSubDepartmentUser && (
              <TitleOverall>
                <Headline3>Benchmark Overall</Headline3>
                <OverallScore>
                  <Headline3>{round(apiData.overall.score, 1)}% </Headline3>
                  {!isSelf && (
                    <Body3 color="battleShipGray">
                      (
                      {apiData.overall.change
                        ? round(apiData.overall.change, 1)
                        : 0}
                      %)
                    </Body3>
                  )}
                </OverallScore>
              </TitleOverall>
            )}
            {apiData.data.map((res, index) => {
              const withEqScores = res.subCategory.filter(
                (cat) => cat.categoryType === 'subCategory' && cat.eqScore
              );
              const departmentOverallEq = withEqScores.length
                ? sum(withEqScores.map((s) => s.eqScore)) / withEqScores.length
                : '';
              return (
                <>
                  <CardContainer>
                    <BencharmkOverallListItem isOpened={toggle[index]}>
                      <BencharmkOverallListItemContent>
                        <CardContent>
                          <CardTitle>
                            <Headline4>{res.name}</Headline4>
                          </CardTitle>
                          <CardOverall>
                            {!isSubDepartmentUser && (
                              <>
                                <CardScore>{round(res.score, 1)}%</CardScore>
                                {!isSelf && (
                                  <Body5 color="battleShipGray">
                                    ({round(res.change, 1) > 0 ? '+' : ''}
                                    {round(res.change, 1)}%)
                                  </Body5>
                                )}
                              </>
                            )}
                            {departmentOverallEq && (
                              <div
                                className={`bol-overal-eq f-left h-13px w-30px border-radius-7 lh-16 text-center f-12 ml-10 pl-3 pb-6 pr-3 pt-3 ${'background-' +
                                  getEqBgColor(round(departmentOverallEq))
                                  }`}
                              >
                                {round(departmentOverallEq, 1).toFixed(1)}
                              </div>
                            )}
                            <DropdownArrowContainer
                              onClick={() => handleCollapsible(index)}
                              expanded={toggle[index]}
                            >
                              <DownArrowIcon />
                            </DropdownArrowContainer>
                          </CardOverall>
                        </CardContent>
                        <HoteLScoreContainer isOpened={toggle[index]}>
                          <HotelScoreTitle isToggle={toggle[index]}>
                            <Headline6>Hotel % Score</Headline6>
                          </HotelScoreTitle>
                        </HoteLScoreContainer>
                      </BencharmkOverallListItemContent>
                    </BencharmkOverallListItem>
                  </CardContainer>
                  {res.subCategory.map((subCat, i) => {
                    return (
                      // tslint:disable-next-line:jsx-key
                      <Collapse isOpened={toggle[index]}>
                        <BenchmarkOverallCollapseContent>
                          <DepartamentCard isTheme={i % 2 === 0}>
                            <DepartamentTitle>
                              <DepartamentText>
                                <a
                                  onClick={() =>
                                    isSelf
                                      ? navigate(
                                        '/selfAssessmentSummaryStandards',
                                        {
                                          state: {
                                            apiData,
                                            isSelf,
                                            assessmentId,
                                            standardType: standard,
                                            categoryId: res.id,
                                            subCategoryId: subCat.id,
                                            tempData,
                                            imgAttach,
                                            audioAttach,
                                            performanceClassificationSummary:
                                              performanceClassification,
                                            duplicateCategoryAssessed,
                                            template: passsTemplate,
                                            selfAssessmentData,
                                            selfStayStart,
                                          },
                                        }
                                      )
                                      : navigate('/assesmentStandard', {
                                        state: {
                                          apiData,
                                          isSelf,
                                          assessmentId,
                                          tempData,
                                          categoryId: res.id,
                                          subCategoryId: subCat.id,
                                          standardType: standard,
                                          performanceClassificationSummary:
                                            performanceClassification,
                                        },
                                      })
                                  }
                                >
                                  <Body4 className="text-underline">
                                    {subCat.name}
                                    {(subCat.mealPeriod || subCat.outlet) && (
                                      <span
                                        style={{
                                          fontSize: '12px',
                                          fontStyle: 'italic',
                                        }}
                                      >
                                        {'' +
                                          `${subCat.mealPeriod
                                            ? ' - ' +
                                            translateMealPeriodLabel(
                                              subCat.mealPeriod
                                            )
                                            : ''
                                          }${subCat.outlet
                                            ? ' - ' + subCat.outlet
                                            : ''
                                          }`}
                                      </span>
                                    )}
                                  </Body4>
                                </a>
                              </DepartamentText>
                              <DepartamentOverall>
                                <Headline5 color="eerieBlack">
                                  {round(subCat.score, 1)}%
                                </Headline5>{' '}
                                {!isSelf && (
                                  <Body5 color="battleShipGray">
                                    ({round(subCat.change, 1) > 0 ? '+' : ''}
                                    {round(subCat.change, 1)}%)
                                  </Body5>
                                )}
                              </DepartamentOverall>
                            </DepartamentTitle>
                            <DepartamentDescription>
                              <DepartamentLabelContainer>
                                {subCat.departmentEq && (
                                  <span
                                    className={`${'background-' +
                                      getEqBgColor(
                                        round(subCat.departmentEq.templateEqValue)
                                      )
                                      } border-radius-10 text-center color-${getEqTextColor(
                                        round(subCat.departmentEq.templateEqValue)
                                      )}`}
                                  >
                                    {subCat.departmentEq
                                      ? `${round(
                                        subCat.departmentEq.templateEqValue,
                                        1
                                      ).toFixed(1)} - ${subCat.departmentEq
                                        .templateEqDescription
                                      }`
                                      : ''}
                                  </span>
                                )}
                              </DepartamentLabelContainer>
                              <DepartamentIconsContianer>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEqData({
                                      ...subCat.departmentEq,
                                      depCommentary: subCat.departmentCommentary,
                                      subName: subCat.name,
                                      time:
                                        subCat.dateTimeFormat === 'date'
                                          ? subCat.date
                                          : subCat.dateTime,
                                    });
                                    subCat.departmentEq ||
                                      subCat.departmentCommentary
                                      ? setOpen(true)
                                      : setOpen(false);
                                  }}
                                >
                                  <Icon
                                    kind={
                                      subCat.departmentEq ||
                                        subCat.departmentCommentary
                                        ? 'commentgreen'
                                        : 'commentgrey'
                                    }
                                    width={25}
                                    height={25}
                                    className="fill-58c3bb"
                                  />
                                </div>
                                {audioAttach.filter(
                                  (o) => o.templateCategoryId === subCat.id
                                ) &&
                                  audioAttach.filter(
                                    (o) => o.templateCategoryId === subCat.id
                                  ).length > 0 ? (
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAudio(
                                        audioAttach
                                          .filter(
                                            (o) =>
                                              o.templateCategoryId === subCat.id
                                          )
                                          .map((a) => a)
                                      );
                                      setAudioOverlayOpened(true);
                                    }}
                                  >
                                    <Icon
                                      kind="speakergreen"
                                      width={25}
                                      height={25}
                                      className="fill-979797"
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    <Icon
                                      kind="speakergrey"
                                      width={25}
                                      height={25}
                                      className="fill-979797"
                                    />
                                  </div>
                                )}

                                {imgAttach.filter(
                                  (o) => o.templateCategoryId === subCat.id
                                ) &&
                                  imgAttach.filter(
                                    (o) => o.templateCategoryId === subCat.id
                                  ).length > 0 ? (
                                  <ImageOverlay
                                    images={imgAttach
                                      .filter(
                                        (o) => o.templateCategoryId === subCat.id
                                      )
                                      .map((a) => ({ source: a.url }))}
                                    target={
                                      <div>
                                        {' '}
                                        <Icon
                                          kind="imagegreen"
                                          width={25}
                                          height={25}
                                          className="fill-979797"
                                        />
                                      </div>
                                    }
                                  />
                                ) : (
                                  <div>
                                    <Icon
                                      kind="imagegrey"
                                      width={25}
                                      height={25}
                                    />
                                  </div>
                                )}
                                <div>
                                  <Icon
                                    kind="edit-diary"
                                    height={20}
                                    width={20}
                                    onClick={() => {
                                      setPressHoldData(subCat);
                                      setOpenPressHold(true);
                                    }}
                                  />
                                </div>
                              </DepartamentIconsContianer>
                            </DepartamentDescription>
                          </DepartamentCard>
                        </BenchmarkOverallCollapseContent>
                      </Collapse>
                    );
                  })}
                </>
              );
            })}
            {audio.length > 0 && (
              <OverlayAudio
                isOpen={audioOverlayOpened}
                setOpen={setAudioOverlayOpened}
                audioUrls={audio}
                setAudio={setAudio}
              />
            )}
          </AssessmentContainer>
        )}
      </div>
    </>
  );
};

export default Assessment;
